module.exports = __webpack_public_path__ + "img/fivety.feb3be0e.png";